import React from "react";
import {
  Box,TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const factoryItemList = this.props.factoryItemList;
    const searchData = this.props.searchData;
    const allColumnNames = this.props.columnNames
    const itemRequestDetail = this.props.itemRequestDetail
    const cellStyle = {
      border: '1px solid black',
      padding: '2px 4px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <h3><center><u>Factory Item Details Installments Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
        <h4><center>Route : {itemRequestDetail.routeID == 0 ? 'All Route' : searchData.routeName} </center></h4>
        <h4><center>Factory Item: {itemRequestDetail.factoryItemID == 0 ? 'All' : searchData.itemName} - Item Category : {itemRequestDetail.itemCategoryID == 0 ? 'All' : searchData.categoryName}</center></h4>
        <h4><center>  Reg No : {itemRequestDetail.registrationNumber === "" ? 'All Reg No' : itemRequestDetail.registrationNumber}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1100}>
            <TableContainer style={{ marginLeft: '5px', overflow: 'auto' }}>
              <Table aria-label="caption table" style={{ borderCollapse: 'collapse', width: '99%' }}>
                <TableHead>
                  <TableRow style={{ border: '1px solid black', pageBreakInside: 'avoid' }}>
                    {
                      allColumnNames.map((object, index) => {
                        return (
                          <TableCell key={index} style={{ border: '1px solid black' }} align={'left'}>{object.title}</TableCell>
                        )
                      })
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {factoryItemList.map((data, index) => {
                    const monthPayments = {};
                    if (data.paymentAffectMonthArray && Array.isArray(data.paymentAffectMonthArray)) {
                      data.paymentAffectMonthArray.forEach(payment => {
                        monthPayments[payment.affectedMonth] = payment.perInstallmentPrice;
                      });
                    }

                    const currentDate = new Date();
                    const currentMonth = currentDate.getMonth() + 1; 
                    const monthNumbers = [];
                    
                    for (let i = -1; i <= 2; i++) {
                      const targetMonth = currentMonth + i;
                      let monthNumber;
                      
                      if (targetMonth <= 0) {
                        monthNumber = 12 + targetMonth; 
                      } else if (targetMonth > 12) {
                        monthNumber = targetMonth - 12; 
                      } else {
                        monthNumber = targetMonth; 
                      }
                      monthNumbers.push(monthNumber);
                    }

                    return (
                      <TableRow key={index} style={{ pageBreakInside: 'avoid' }}>
                        <TableCell size="small" align="left" style={cellStyle}>
                          {data.routeName}
                        </TableCell>
                        <TableCell size="small" align="left" style={cellStyle}>
                          {data.date.split('T')[0]}
                        </TableCell>
                        <TableCell size="small" align="left" style={cellStyle}>
                          {data.registrationNumber}
                        </TableCell>
                        <TableCell size="small" align="left" style={cellStyle}>
                          {data.name}
                        </TableCell>
                        <TableCell size="small" align="left" style={cellStyle}>
                          {data.categoryName}
                        </TableCell>
                        <TableCell size="small" align="left" style={{
                          border: '1px solid black',
                          padding: '2px 4px',
                          fontSize: '0.9rem',
                          width: '100px'
                        }}>
                          {data.itemName}
                        </TableCell>
                        <TableCell size="small" align="center" style={cellStyle}>
                          {data.approvedQuantity}
                        </TableCell>
                        
                        {monthNumbers.map((monthNum, monthIndex) => {
                          const payment = monthPayments[monthNum];
                          return (
                            <TableCell key={monthIndex} size="small" align="right" style={cellStyle}>
                              {payment ? 
                                payment.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 
                                "-"
                              }
                            </TableCell>
                          );
                        })}
                        <TableCell size="small" align="right" style={cellStyle}>
                          {data.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}